// @flow
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import FeatureToggle from './FeatureToggle';

const mapStateToProps = ({ flags }) => ({ flags });

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FeatureToggle);



// WEBPACK FOOTER //
// ./components/FeatureToggle/index.js